import { render, staticRenderFns } from "./client-feature-create-modal.vue?vue&type=template&id=4ce79ef8"
import script from "./client-feature-create-modal.vue?vue&type=script&lang=js"
export * from "./client-feature-create-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports